import React from 'react';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import cx from 'classnames';
import { DateInfo } from 'govbr.frontend.policy/components';
import { getVideoFileSource } from 'govbr.frontend.policy/components/Blocks/VideoContent/utils';
import TagsUFs from 'govbr.frontend.policy/components/TagsUFs';

import styles from './Listing.module.less';
import { Description, Title } from './ListingParts';

export const Video = ({ item, isEditMode }) => {
  const { url, file, subjects, Subject } = item;
  const tags = subjects || Subject;
  const fileSource = getVideoFileSource(file);
  const videoUrl = url || (file ? `${fileSource}/${file.filename}` : null);

  const renderVideo = () => {
    if (videoUrl) {
      return (
        <div className={cx(styles.videoWrapper, 'mb-3')}>
          <Body data={{ url: videoUrl }} isEditMode={isEditMode} />
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className={cx(styles.body, styles.mediaGallery)}>
        <Title item={item} isEditMode={isEditMode} />
        {renderVideo()}
        <Description item={item} hideDatePublished />
      </div>
      <DateInfo item={item} />
      <TagsUFs
        className={'mt-1 mt-sm-0'}
        content={{
          subjects: tags,
        }}
      />
    </>
  );
};
